import { render } from "./UserInfoPage.vue?vue&type=template&id=47003df6&scoped=true"
import script from "./UserInfoPage.vue?vue&type=script&lang=js"
export * from "./UserInfoPage.vue?vue&type=script&lang=js"

import "./UserInfoPage.vue?vue&type=style&index=0&id=47003df6&scoped=true&lang=css"

import exportComponent from "/var/www/vhosts/fep.theismailiusa.org/srv/ibsreg-test.theismailiusa.org/github-httpdocs/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47003df6"]])

export default __exports__